export const EsteticPriceData = [
    {
        id: 1,
        service: 'Профессиональная гигиена полости рта и зубов',
        price: '5000',
    },
   
    {
        id: 2,
        service: 'Профессиональное отбеливание зубов',
        price: '20000',
    },
    {
        id: 3,
        service: 'Домашнее отбеливание',
        price: '12000',
    }
]